import HeroBanner      from '../components/home/HeroBanner'
import ServicesSection from '../components/home/ServicesSection'
import PackagesPreview from '../components/home/PackagesPreview'
import WhyUs           from '../components/home/WhyUs'
import GalleryPreview  from '../components/home/Gallery'
import Testimonials    from '../components/home/Testimonials'
import CTA             from '../components/home/CTA'

export default function Home() {
  return (
    <>
      <HeroBanner />
      <div id="services-section">
        <ServicesSection />
      </div>
      <PackagesPreview />
      <WhyUs />
      <GalleryPreview />
      <Testimonials />
      <CTA />
    </>
  )
}
